var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-briefing-create","toptitle":_vm.project.title,"title":"Briefing erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-briefing-form',{attrs:{"project-briefing":_vm.projectBriefing,"project":_vm.project}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }